export const APP_VERSION = '1.0.0'
export const APP_ID = "com.codespaceapps.aibookweb"
export const SUPPORT_EMAIL = 'support.sparkle@codespaceapps.co'
export const FAQS = [
  {
    question: "Why do I need Sparkle app? ",
    answer: "Sparkle delivers 15-minute summaries of top nonfiction books, packed with key insights and practical takeaways. It helps you learn efficiently, discover valuable ideas, and focus on books that truly matter to you. Whether you’re short on time or looking for daily inspiration, Sparkle makes self-growth simple and effective."
  },
  {
    question: "How can I access to the app?",
    answer: "Once you enter your email address, you'll receive an email containing a temporary password and download links for the App Store and Google Play. Simply install the app to access your account."
  },
  {
    question: "How can I cancel my subscription?",
    answer: `It's easy to cancel. Simply contact our friendly support team at ${SUPPORT_EMAIL}, and we’ll assist you with the process.`
  },
]

export const BACKEND_BASE_URL =
  window.location.href.indexOf('localhost') >= 0 ? 'http://localhost:5000' : ''